import styled, { css } from 'styled-components'
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider'
import type { SwitchProps } from './types'

export const Label = styled.div`
  padding: var(--space-100) 0;
  display: flex;
  align-items: center;
  font-size: inherit;
  color: ${getAutomatedStyleProp('colorOnBackground', 'var(--text-primary)')};
`

export const Track = styled.div<{ $size: SwitchProps['size'] }>`
  height: 31px;
  width: 51px;
  padding: 2px;
  border-radius: 27px;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: flex-start;
  background: var(--border-secondary);

  ${({ $size }) =>
    $size === 'small' &&
    css`
      height: var(--space-500);
      width: 32px;
      padding: 2px;
      border-radius: var(--space-400);
    `}
`

export const Handle = styled.div<{ $size: SwitchProps['size'] }>`
  height: 27px;
  width: 27px;
  border-radius: 100%;
  background: var(--bg-primary);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);

  ${({ $size }) =>
    $size === 'small' &&
    css`
      height: var(--space-400);
      width: var(--space-400);
    `}
`

export const Container = styled.label<{
  $disabled: SwitchProps['disabled']
  $checked: boolean
  $side: SwitchProps['side']
  $size: SwitchProps['size']
}>`
  display: flex;
  align-items: center;
  gap: var(--space-400);
  user-select: none;

  &:hover {
    cursor: pointer;
  }

  ${({ $size }) =>
    $size === 'small' &&
    css`
      gap: var(--space-200);
    `}

  ${({ $side }) =>
    $side === 'right' &&
    css`
      flex-direction: row-reverse;
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;

      ${Label} {
        cursor: not-allowed;
      }

      ${Track} {
        cursor: not-allowed;
      }

      ${Handle} {
        box-shadow: none;
      }
    `}

  ${({ $checked }) =>
    $checked &&
    css`
      ${Track} {
        justify-content: flex-end;
        background: var(--bg-brand);
      }
    `}
`

export const Description = styled.div`
  margin-top: var(--space-100);
  color: var(--text-secondary);
  font-size: var(--font-size-300);

  a {
    text-decoration: underline;

    &:hover {
      color: var(--text-brand);
    }
  }
`
